export default "__VITE_ASSET__BaEU1$9r__"